import React, { useContext } from 'react'

import Map, { MapProps } from '@/components/shared/map'
import MapContext from '@/context/map'

const MapStateful: React.FC<MapProps> = (mapProps) => {
    const {
        selectors: { mapContent },
    } = useContext(MapContext)

    return <Map jsonMap={mapContent} {...mapProps} />
}

export default MapStateful
